import type { ClientPodStatus } from "@backstage/plugin-kubernetes-common";

type AggregatedResource = {
  currentUsage: number;
  requestTotal: number;
  limitTotal: number;
};

export type AggregatedRuntimeResources = {
  podCount: number;
  cpu: AggregatedResource;
  memory: AggregatedResource;
};

const toNumber = (value: number | string): number => Number(value) || 0;

export const aggregatePodMetrics = (podMetrics: ClientPodStatus[]): AggregatedRuntimeResources => {
  return podMetrics.reduce<AggregatedRuntimeResources>(
    (summary, podMetric) => {
      summary.podCount += 1;

      summary.cpu.currentUsage += toNumber(podMetric.cpu.currentUsage);
      summary.cpu.requestTotal += toNumber(podMetric.cpu.requestTotal);
      summary.cpu.limitTotal += toNumber(podMetric.cpu.limitTotal);

      summary.memory.currentUsage += toNumber(podMetric.memory.currentUsage);
      summary.memory.requestTotal += toNumber(podMetric.memory.requestTotal);
      summary.memory.limitTotal += toNumber(podMetric.memory.limitTotal);

      return summary;
    },
    {
      podCount: 0,
      cpu: {
        currentUsage: 0,
        requestTotal: 0,
        limitTotal: 0,
      },
      memory: {
        currentUsage: 0,
        requestTotal: 0,
        limitTotal: 0,
      },
    },
  );
};

export const formatMillicores = (value: number): string => `${Math.round(value * 1000)}m`;

export const formatMebibytes = (value: number): string => `${Math.round(value / 1024 / 1024)}MiB`;
